import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog } from '../../common/components';
import ProfilesDataTable from './components/ProfilesDataTable';
import ProfilesPagination from './components/ProfilesPagination';
import ProfileDialog from './components/ProfileDialog';
import AccessDialog from './components/AccessDialog';
import { useProfilesTable } from './hooks/useProfilesTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const ProfilesTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    accessDialogOpen,
    editMode,
    selectedProfile,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSave,
    handleEdit,
    handleDelete,
    handleAccessEdit,
    handleCheckBoxChange,
    handleSaveAccess,
    deleteConfirmOpen,
    profileToDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useProfilesTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <FormTitleBox
        title="Administración | Perfiles"
        showButton={true}
        buttonText="Agregar Perfil"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar perfil"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <ProfilesDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAccessEdit={handleAccessEdit}
        LoadingComponent={LoadingSkeleton}
      />

      <ProfilesPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ProfileDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedProfile={selectedProfile}
        onInputChange={handleInputChange}
        onSave={handleSave}
      />

      <AccessDialog
        openAccess={accessDialogOpen}
        handleClose={handleCloseDialog}
        selectedProfile={selectedProfile}
        handleCheckBoxChange={handleCheckBoxChange}
        handleSaveAccess={handleSaveAccess}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="perfil"
        message={`¿Está seguro que quiere eliminar el perfil "${profileToDelete?.name}" de forma permanente?`}
      />
    </Box>
  );
};

export default ProfilesTable;
